(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hush-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  const initializeHushReviews = (root = document) => {
    root.querySelectorAll('[data-hush-reviews]').forEach((carousel) => {
      if (carousel.dataset.initialized === 'true') return;
      carousel.dataset.initialized = 'true';

      const track = carousel.querySelector('[data-review-track]');
      const cards = Array.from(carousel.querySelectorAll('[data-review-card]'));
      const dots = Array.from(carousel.querySelectorAll('[data-review-dot]'));
      const previous = carousel.querySelector('[data-review-previous]');
      const next = carousel.querySelector('[data-review-next]');
      if (!track || cards.length < 2) return;

      const activeIndex = () => {
        const left = track.scrollLeft;
        return cards.reduce((closest, card, index) => {
          const closestDistance = Math.abs(cards[closest].offsetLeft - left);
          const distance = Math.abs(card.offsetLeft - left);
          return distance < closestDistance ? index : closest;
        }, 0);
      };

      const updateDots = () => {
        const active = activeIndex();
        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === active);
          if (index === active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };

      const goTo = (index) => {
        const target = (index + cards.length) % cards.length;
        track.scrollTo({ left: cards[target].offsetLeft, behavior: 'smooth' });
      };

      let frame;
      previous?.addEventListener('click', () => goTo(activeIndex() - 1));
      next?.addEventListener('click', () => goTo(activeIndex() + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(updateDots);
      }, { passive: true });
      updateDots();
    });
  };

  initializeHushReviews();
  document.addEventListener('shopify:section:load', (event) => initializeHushReviews(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
